import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { LocaleSync } from '@/components/LocaleSync';
import { PwaInstallBanner } from '@/components/PwaInstallBanner';
import { ToastProvider } from '@/components/ToastProvider';
import { router } from '@/router';
import { AppThemeProvider } from '@/theme/AppThemeProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <LocaleSync />
            <RouterProvider router={router} />
            <PwaInstallBanner />
          </AuthProvider>
        </ToastProvider>
      </AppThemeProvider>
    </QueryClientProvider>
  );
}
